<tt-page *ngIf="!!edit">
    <tt-card class="col-xs-12 col-md-4 sp-0">
        <tt-input ttLabel="user_name" [ttModel]="edit.user_name" ttReadonly></tt-input>
        <tt-editor ttLabel="email_signature" [(ttModel)]="edit.email_signature" [(ttProcessing)]="readyEmailSignature"></tt-editor>
        <tt-button-save ttText="portalusersignature_save" (ttClick)="saveChanges()" [ttLoading]="readyEmailSignature === false"></tt-button-save>
    </tt-card>
</tt-page>
